import { Injectable } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';

import { BehaviorSubject, Observable } from 'rxjs';
import { ErrorModalComponent } from '@modals/error-modal/error-modal.component';
import { ComponentContainerModalComponent } from '@modals/component-container-modal/component-container-modal.component';
import { LoaderService, NotificationService } from '@core';
import { ConfirmModalComponent } from '@shared/modals/confirm-modal/confirm-modal.component';


@Injectable({
    providedIn: 'root'
})
export class UtilsService {

    modals: any;
    menu$: BehaviorSubject<boolean> = new BehaviorSubject(false);

    constructor(private modalService: BsModalService, private loaderService: LoaderService, 
            private notificationService: NotificationService) {
        this.modals = {
            confirm: {
                component: ConfirmModalComponent
            },
            error: {
                component: ErrorModalComponent
            }
            // insert there new default modal
        };
    }

    inLoading(state: boolean) {
        this.loaderService.inLoading(state);
    }

    notify(type: string, data = {}, className?: string) {
        this.notificationService.notify(type, data, className);
    }

    openMenu(isOpen: boolean) {
        this.menu$.next(isOpen);
    }

    toggleMenu() {
        this.menu$.next(!this.menu$.getValue());
    }


    /**
     * @param component name of component or component itself
     * @param data to pass for component selected
     * @param className class for modal
     */
    openModal(component = null, data = {}, className?: string): Observable<any> {
        const defaultClass = "modal-lg";
        if (!component) throw ("Dialog not found");
        let embedComponent = false;

        if (typeof component === "string") {
            className = className || this.modals[component].defaultClass || defaultClass;
            component = this.modals[component].component;
        } else {
            className = className || defaultClass;
            embedComponent = true;
            data = { ...data, component: component }
        }

        this.modalService.show(embedComponent ? ComponentContainerModalComponent : component,
            {
                initialState: data,
                class: className
            }
        );
        return this.modalService.onHidden;
    }

}